import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { get } from '../lib/api';
import VerificationDialog from './VerificationDialog';

const money = value => new Intl.NumberFormat('en-PH', { style: 'currency', currency: 'PHP' }).format(Number(value || 0));

export default function DeliveryRatesDialog({ onClose, vendorId }) {
  const [pricing, setPricing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    get('/platform-rates/delivery-pricing' + (vendorId ? '?vendorId=' + encodeURIComponent(vendorId) : ''))
      .then(result => { if (active) setPricing(result.pricing); })
      .catch(e => { if (active) setError(e.response?.data?.message || 'Unable to load delivery rates. Close and try again.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [vendorId]);
  const starts = pricing?.standardWeightKg != null
    ? [{ ...pricing, name: pricing.standardName || 'Standard distance rate', minWeightKg: 0 }, { ...pricing.heavyRate, minWeightKg: pricing.standardWeightKg }, ...(pricing.additionalRates || [])]
    : pricing ? [{ ...pricing, name: pricing.standardName || 'Standard distance rate' }] : [];

  return <VerificationDialog title="Delivery pricing" fullWidth onClose={onClose} closeLabel={<X className="h-5 w-5" aria-hidden="true" />}>
    <p className="mb-4 text-sm text-slate-500">Each store's delivery uses its total item weight and the road distance from pickup to drop-off. Charge = base fee + distance beyond the included kilometers × additional rate.</p>
    {loading ? <p role="status">Loading delivery rates...</p> : error ? <p role="alert" className="text-sm text-red-700">{error}</p> : !pricing ? <p>Delivery pricing has not been configured.</p> : <div className="overflow-x-auto rounded-xl border border-slate-200">
      <table className="w-full min-w-[540px] text-left text-sm">
        <caption className="sr-only">Delivery rates by weight range</caption>
        <thead className="bg-slate-50 text-xs text-slate-600"><tr>{['Rate', 'Weight range (kg)', 'Base fee', 'Included distance', 'Additional fee / km'].map(label => <th key={label} scope="col" className="px-4 py-3 font-semibold">{label}</th>)}</tr></thead>
        <tbody className="divide-y divide-slate-100">{starts.map((rate, index) => <tr key={index}>
          <th scope="row" className="px-4 py-3 font-medium">{rate.name}</th>
          <td className="whitespace-nowrap px-4 py-3">{rate.minWeightKg == null ? 'All weights' : starts[index + 1] ? `${rate.minWeightKg} to below ${starts[index + 1].minWeightKg}` : `${rate.minWeightKg} and above`}</td>
          <td className="whitespace-nowrap px-4 py-3">{money(rate.baseFee)}</td>
          <td className="whitespace-nowrap px-4 py-3">{rate.includedKm} km</td>
          <td className="whitespace-nowrap px-4 py-3">{money(rate.perKm)}</td>
        </tr>)}</tbody>
      </table>
    </div>}
  </VerificationDialog>;
}
